import React, { useState } from "react"
import { TestTimeIndicator } from "../../../../../services/utils/practice-test-util"

interface Props {
    title: string
    onTimeSelected: (testTimeIndicator: TestTimeIndicator) => void
}

export default function Welcome(props: Props) {
    const { title, onTimeSelected } = props
    const [selectedTime, setSelectedTime] = useState<TestTimeIndicator>("regular")
    const handleStartTest = () => {
        if (selectedTime) {
            onTimeSelected(selectedTime)
        } else {
            alert("Please select a test timing option.")
        }
    }

    return (
        <div className="page-msg-fullscreen page--ptWelcome">
            <div className="container w-100 mx-auto">
                <div className="row justify-content-center">
                    <div className="col-12" style={{ maxWidth: '940px' }}>
                        <img
                            alt="Winward Academy"
                            className="mx-auto d-block mb-4"
                            src="/assets/images/ww_logo_white.svg"
                            width="130"
                            height="103"
                        />
                        <h1 className="page-title text-center w-100 d-block">
                            Welcome to your practice {title}
                        </h1>
                        <div className="img-frame with-overlap">
                            <img
                                alt="SAT"
                                className="d-block mx-auto"
                                width="505"
                                src="/assets/images/dashboard/practice/sat-online-noframe-2x.png"
                            />
                        </div>
                        <div className="card-select with-overlap">
                            <div className="card-select--inner mx-auto" style={{ maxWidth: '505px' }}>
                                <h5 className="mb-4">
                                    Please select your test timing and click START TEST when you're ready to begin.
                                </h5>
                                <div className="form-check--wrapper d-flex flex-column flex-md-row justify-content-md-center mb-4">
                                    <div className="form-check mb-2 mb-md-0 px-2">
                                        <label className="form-check-label">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="testTime"
                                                value="regular"
                                                checked={selectedTime === "regular"}
                                                onChange={(e) => setSelectedTime(e.target.value as TestTimeIndicator)}
                                            />
                                            Regular Time
                                        </label>
                                    </div>
                                    <div className="form-check mb-2 mb-md-0 px-2">
                                        <label className="form-check-label">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="testTime"
                                                value="extended1"
                                                checked={selectedTime === "extended1"}
                                                onChange={(e) => setSelectedTime(e.target.value as TestTimeIndicator)}
                                            />
                                            1.5x Time
                                        </label>
                                    </div>
                                    <div className="form-check mb-0 pb-1 pb-md-0 px-2">
                                        <label className="form-check-label">
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="testTime"
                                                value="extended2"
                                                checked={selectedTime === "extended2"}
                                                onChange={(e) => setSelectedTime(e.target.value as TestTimeIndicator)}
                                            />
                                            Double Time
                                        </label>
                                    </div>
                                </div>
                                <div className="">
                                    <button onClick={handleStartTest} className="btn btn--bg-white">
                                        Start <span className="d-none d-sm-inline">{title}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}